import React, { Component } from 'react';
import { Link } from "react-router-dom";
import TopNavigation from './TopNavigation';
import Footer from './Footer';
import logoStacked from './img/logo-complex-boss-mobile.png';
import logoHorizontal from './img/logo-complex-boss-desktop.png';
import gsap from "gsap";
import ScrollTrigger from "gsap/ScrollTrigger";

gsap.registerPlugin(ScrollTrigger);

type HomeState = {
    successMsg: boolean
    errorMsg: boolean
}

class Home extends Component<{}, HomeState> {
    constructor(props: any) {
        super(props);

        this.state = {
            successMsg: false,
            errorMsg: false
        };

        this.handleSubmission = this.handleSubmission.bind(this);
        this.submissionMessage = this.submissionMessage.bind(this);
    }

    signupFormEndpoint = 'https://links.iterable.com/lists/publicAddSubscriberForm?publicIdString=1b734110-435f-44c8-bf25-cd7f9996a488';

    async postData(url = '', data = new FormData()) {
        try {
            await fetch(url, {
                method: 'POST',
                body: data
            }).then((response) => {
                if (response.status >= 400 && response.status < 600) {
                    throw new Error("Bad response from server");
                }

                return Promise.resolve(response);
            });
        } catch (err) {
            return Promise.reject(err);
        }
    }

    handleSubmission(e: any) {
        e.preventDefault();

        const formEl = e.target;
        const formData = new FormData(formEl);

        this.postData(this.signupFormEndpoint, formData)
            .then((data) => {
                this.setState({
                    successMsg: true
                });
            })
            .catch((err) => {
                this.setState({
                    errorMsg: true
                });
                console.error('err', err);
            });
    }

    submissionMessage() {
        if (this.state.successMsg) {
            return (<div>
                <h2>Thanks for joining our mailing list</h2>
                <p>You've been successfully subscribed - thanks!</p>
            </div>);
        }

        if (this.state.errorMsg) {
            return (<div>
                <h2>An error has occured</h2>
                <p>Please refresh the page and try again</p>
            </div>);
        }
    }

    render() {
        return (
            <React.Fragment>
                <section id="home">
                    <div className="wrapper">
                        <TopNavigation />

                        <header id="header">
                            <div className="header__wrapper">
                                <img className="logo logo--stacked" src={logoStacked} alt="logo stacked" />
                                <img className="logo logo--horizontal" src={logoHorizontal} alt="logo horizontal" />
                                <p className="header__heading">BIPOC OWNERS WITH SUCCESS-BASED SERVICES</p>
                            </div>
                        </header>

                        <h1 className="section-heading" data-animation="animate__fadeInDown">A 12-week mentorship program for US-based BIPOC, Women, and LGBTQI small businesses, supported by Complex Networks’ brand-building expertise.</h1>

                        <form className="iterable-signup-form"
                            name="iterable_optin"
                            data-animation="animate__fadeInDown"
                            onSubmit={this.handleSubmission}>

                            <div style={{display: this.state.successMsg || this.state.errorMsg ? 'none' : 'block'}}>
                                <h3 className="form__title">Thank you for your interest in Complex B.O.S.S.</h3>

                                <p className="form__copy">Applications for 2022 mentorship program will open this summer.<br/>
                                    Stay tuned for 2022 dates and announcements.</p>

                                <input type="hidden"
                                    name="newsletter_boss"
                                    value="true" />

                                <input type="email"
                                    id="email"
                                    name="email"
                                    size={22}
                                    placeholder="Your email address"
                                    autoComplete="email"
                                    required/>

                                <button type="submit" className="form__submit">GET NOTIFIED</button>
                            </div>

                           {this.submissionMessage()}
                        </form>

                        <div className="btn__wrapper">
                            <Link className="btn btn--participants d500" to="/participants" data-animation="animate__fadeInDown">EXPLORE THE 2021 PARTICIPANTS</Link>
                        </div>

                        <a className="questions-contact d600" href="mailto:boss@complexnetworks.com" data-animation="animate__fadeInDown">
                            If you have any questions, please contact us at <span className="pseudolink">boss@complexnetworks.com</span>
                        </a>
                    </div>{/* wrapper */}
                </section>
                <Footer />
            </React.Fragment>
        );
    }

    componentDidMount() {
        var animatedItems = document.querySelectorAll('[data-animation]');

        var animatedItemsOptions = {
            root: null,
            rootMargin: '0px',
            threshold: 0.7,
        };

        var animatedItemsCallback = function(entries: any, observer: any) {
            entries.forEach(function(entry: any) {
                if (entry.intersectionRatio > 0) {
                    const animationClasses = entry.target.dataset.animation.split(' ');
                    animationClasses.forEach((animationClass: string) => {
                        entry.target.classList.add(animationClass);
                    });
                    entry.target.classList.add('animate__animated');
                }
            });
        };

        var animatedItemsObserver = new IntersectionObserver(animatedItemsCallback, animatedItemsOptions);
        animatedItems.forEach(function(item){
            animatedItemsObserver.observe(item);
        });

        ScrollTrigger.create({
            trigger: '#header',
            id: 'header',
            start: 'top top+=20',
            end: () => `${document.body.clientHeight}`,
            toggleActions: 'play reverse none reverse',
            toggleClass: {
                targets: '#header',
                className: "sticky"
            },
            // markers: true
        });
    }
}

export default Home;
